<div class="settings-container page-shell">
  <div class="header">
    <div class="header-left">
      <span class="header-title">{{ "menu.integration" | translate }}</span>
      <div class="header-tabs" role="tablist">
        <button
          type="button"
          role="tab"
          class="header-tab"
          [class.header-tab--active]="selectedTabIndex === 0"
          [attr.aria-selected]="selectedTabIndex === 0"
          (click)="onTabChange(0)"
        >
          Google
        </button>
        <button
          type="button"
          role="tab"
          class="header-tab"
          [class.header-tab--active]="selectedTabIndex === 1"
          [attr.aria-selected]="selectedTabIndex === 1"
          (click)="onTabChange(1)"
        >
          Microsoft
        </button>
        <button
          type="button"
          role="tab"
          class="header-tab"
          [class.header-tab--active]="selectedTabIndex === 2"
          [attr.aria-selected]="selectedTabIndex === 2"
          (click)="onTabChange(2)"
        >
          Calamari
        </button>
      </div>
    </div>
  </div>

  <div class="form">
    <div [hidden]="selectedTabIndex !== 0" id="google">
      <app-google-integration
        [googleExpanded]="true"
        [otherAbsenceEnabled]="isAbsenceEnabled"
        [billingSettings]="billingSettings"
        [activeSyncs]="activeSyncs"
        (absenceEnabledChange)="googleAbsenceEnabled = $event"
      ></app-google-integration>
    </div>
    <div [hidden]="selectedTabIndex !== 1" id="microsoft">
      <app-microsoft-integration
        [microsoftExpanded]="true"
        [otherAbsenceEnabled]="isAbsenceEnabled"
        [billingSettings]="billingSettings"
        [activeSyncs]="activeSyncs"
        (absenceEnabledChange)="microsoftAbsenceEnabled = $event"
      ></app-microsoft-integration>
    </div>
    <div [hidden]="selectedTabIndex !== 2" id="calamari">
      <app-calamari-integration
        [calamariExpanded]="true"
        [otherAbsenceEnabled]="isAbsenceEnabled"
        [billingSettings]="billingSettings"
        [activeSyncs]="activeSyncs"
        (absenceEnabledChange)="calamariAbsenceEnabled = $event"
      ></app-calamari-integration>
    </div>
  </div>

  <div class="dbc1-loading dbc1-loading--overlay" *ngIf="loading">
    <app-loading></app-loading>
  </div>
</div>
